import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}", -1)
      ]))]),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 2.1c0-.608.494-1.106 1.098-1.045a11 11 0 1 1-11.639 7.8c.174-.581.822-.849 1.384-.618s.823.873.664 1.46a8.8 8.8 0 1 0 9.59-6.428C12.494 3.193 12 2.708 12 2.1",
      style: {"transform-origin":"12px 12px","animation":"spin 1s linear infinite"}
    }, null, -1))
  ]))
}
export default { render: render }